import { nsT, useT } from '../../index';
import type zh from './zh-CN';

export type CommonMessages = typeof zh;
export const useCommonT = () => useT<CommonMessages>('common');
export const commonT = nsT<CommonMessages>('common');
